<div class="row">
  <div class="col-sm-0 col-md-1"></div>
  <div class="col-sm-12 col-md-10">
<!--    <h1 class="mat-display-4">Jackdaws love my big sphinx of quartz.</h1>-->
    <div class=" mt-5 mat-body mat-body-1">{{community.description}}</div>
  </div>
  <div class="col-sm-0 col-md-1"></div>
</div>
